<template>
    <div>
        <p class="flag-info" @click="dialogVisible = true">
            <i class="fas fa-flag tableFlag" :class="{'flagged': flagged }" />
            <span v-if="flagged" class="flag-info-count"> x {{ flagCount }} </span>
        </p>
        <el-dialog
            title="Flagged Data"
            :visible.sync="dialogVisible"
            width="90%"
            append-to-body
        >
            <agrinome-table
                ref="flagged-table"
                :key="tableKey"
                :data="row[flagDataPath]"
                :api-mode="false"
                :columns="columns"
                :inline-edit="false"
                :is-delete-permission="false"
                :is-edit-permission="false"
                :checkbox-column="false"
            />
            <!-- <el-table
                :data="row[flagDataPath]"
                style="width: 100%"
                class="fresh-seed-bag-table"
                size="small"
                :header-cell-style="{ background: '#F5F7FA' }"
                border
            >
                <el-table-column
                    type=""
                    width="30"
                />
            
                <el-table-column
                    prop="f"
                    label="Condition"
                    min-width="150"
                />

                <el-table-column
                    prop=""
                    label="Flagged Value"
                    min-width="180"
                />
            
                <el-table-column
                    prop=""
                    label="Flagged At"
                    width="180"
                    :formatter="creationTimeFormatter"
                />
            </el-table> -->
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        "row": {
            type: Object
        },
        "col": {
            type: Object
        },
        "cell": {
            type: String | Number
        },
        "index": {
            type: String | Number
        },
        "customVueComponentParams": {
            type: Object
        }
    },
    data() {
        return {
            dialogVisible: false,
            tableKey: 2,
        };
    },
    computed: {
        flagDataPath() {
            return this.customVueComponentParams.name;
        },
        flagCount() {
            return this.row[this.flagDataPath].length ?? 0;
        },
        flagged() {
            return this.flagCount && this.flagCount > 0;
        },
        columns() {
            return [
                {
                    name: "fieldDataFlag.condition",
                    label: "Condition",
                    sortable: "custom",
                    minWidth: 75
                },
                {
                    name: "flaggedValue",
                    label: "Value",
                    sortable: "custom",
                    minWidth: 70,
                    formatter: this.$_getFlaggedValue()
                },
                {
                    name: "creationTime",
                    label: "Created At",
                    sortable: "custom",
                    minWidth: 20,
                    formatter: this.$_getCreationTimeFormat()
                },
            ];
        },
    },
    methods: {
        creationTimeFormatter(row, column, cell) {
            return this.$_getDateTimeFormat(cell);
        },
    },
};
</script>

<style scoped>
.flag-info {
    color: #606266;
    margin: 0;
    cursor: pointer;
}
.flag-info-count {
    display: inline-block;
    min-width: 24px;
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/DataFlag/index.vue